import SiteLayout from "@/components/feature/SiteLayout";
import HeroCarousel from "@/components/feature/HeroCarousel";
import SectionHeading from "@/components/base/SectionHeading";
import ContentCard from "@/components/feature/ContentCard";
import WorkCard from "@/components/feature/WorkCard";
import CategoryGrid from "@/pages/home/components/CategoryGrid";
import AnalysisStrip from "@/pages/home/components/AnalysisStrip";
import SiteIntro from "@/pages/home/components/SiteIntro";
import { heroSlides } from "@/mocks/hero";
import { newsItems, workItems, analysisItems, sortByDate, sortByPopularity } from "@/lib/content";
import { usePageMeta } from "@/hooks/usePageMeta";

export default function Home() {
  usePageMeta({
    title: "星空动漫 - 最新动漫资讯与作品推荐平台",
    description:
      "星空动漫为广大动漫爱好者提供最新动漫资讯、作品推荐、剧情解析及行业动态，涵盖热门动画、漫画及相关文化内容，助您畅享动漫世界。",
    keywords: "星空动漫,动漫资讯,动画推荐,漫画解析,动漫作品,动画片,动漫社区,动漫文化",
  });

  const latestNews = sortByDate(newsItems).slice(0, 6);
  const recommendedWorks = sortByPopularity(workItems).slice(0, 6);
  const hotAnalysis = sortByPopularity(analysisItems).slice(0, 6);

  return (
    <SiteLayout>
      <div className="mx-auto max-w-page px-4 py-6 md:px-6">
        <h1 className="sr-only">星空动漫 - 面向动漫爱好者的资讯、作品推荐与剧情解析门户</h1>

        <HeroCarousel slides={heroSlides} />

        <section className="mt-10">
          <SectionHeading
            title="频道分类"
            subtitle="按兴趣快速进入对应内容板块"
          />
          <CategoryGrid />
        </section>

        <section className="mt-12 grid grid-cols-1 gap-8 lg:grid-cols-3">
          <div className="lg:col-span-2">
            <SectionHeading
              title="最新资讯"
              subtitle="按发布时间倒序，紧跟动漫圈动态"
              actionLabel="全部资讯"
              actionTo="/news"
            />
            <div className="flex flex-col gap-4">
              {latestNews.map((item) => (
                <ContentCard key={item.id} item={item} variant="row" />
              ))}
            </div>
          </div>

          <div>
            <SectionHeading title="推荐作品" actionLabel="更多作品" actionTo="/works" />
            <div className="grid grid-cols-2 gap-4">
              {recommendedWorks.map((item) => (
                <WorkCard key={item.id} item={item} />
              ))}
            </div>
          </div>
        </section>

        <section className="mt-12">
          <SectionHeading
            title="热门剧情解析"
            subtitle="横向滑动查看更多深度内容"
            actionLabel="全部解析"
            actionTo="/analysis"
          />
          <AnalysisStrip items={hotAnalysis} />
        </section>

        <section className="mt-12">
          <SiteIntro />
        </section>
      </div>
    </SiteLayout>
  );
}